export default __webpack_public_path__ + "static/media/buffer.4ddaec73.png";